import React, { Component } from 'react';
import DeviceList from './DeviceList';
import DeviceSave from './DeviceSave';
import WithRouter from 'custom/withRouter'

class DevicePage extends Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const { params = {}, location = {} } = this.props; // Default params to an empty object
        const registerId = params.id;
        const isSave = registerId || location.pathname === "/manage/device/add";

        return (
            <React.Fragment>
                {isSave ? (
                    <DeviceSave
                        name="deviceSave"
                        params={params}
                        title="Device Info"
                    />
                ) : (
                    <DeviceList title="List of Device" />
                )}
            </React.Fragment>
        );
    }
}

export default WithRouter(DevicePage);